import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { TCITooltip } from '@/components/ui/Tooltip';
import NoteForm from './NoteForm';

interface StudentNotesProps {
  imgUrl: string;
  imgWhiteUrl: string;
  note?: string;
  submitUrl: string;
}

const StudentNotes = ({ imgUrl, imgWhiteUrl, note, submitUrl }: StudentNotesProps) => {
  const [isOpen, setIsOpen] = useState(note?.length > 0);

  return (
    <>
      <TCITooltip>
        <TCITooltip.Trigger asChild>
          <button
            aria-label="Add Note"
            className={`text-action ${isOpen ? 'purple' : 'white'}`}
            data-testid="add-note-button"
            type="button"
            onClick={() => setIsOpen(true)}
          >
            <img
              alt=""
              src={isOpen ? imgWhiteUrl : imgUrl}
            />
          </button>
        </TCITooltip.Trigger>
        <TCITooltip.Content>Add Note</TCITooltip.Content>
      </TCITooltip>
      {isOpen && createPortal(
        <NoteForm studentNote={note} submitUrl={submitUrl} />,
        document.getElementById('student-notes-container'),
      )}
    </>
  );
};

export default StudentNotes;
